import CoreComp from "./CoreComp";

export default CoreComp;
